import { InterventionsList } from '../components/InterventionsList/InterventionsList';
import styles from './InterventionsPage.module.css';

export const InterventionsPage = () => (
  <main className={styles.page}>
    <InterventionsList />
  </main>
);
